import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import {LoaderState} from "./LoaderState";

@Injectable()
export class LoaderService {
    private loaderSubject = new Subject<LoaderState>();
    private shouldShow: boolean;
    loaderState = this.loaderSubject.asObservable();
    constructor() { }
    show() {
        this.shouldShow = true;
        setTimeout(() =>
            {
                if (this.shouldShow)
                    this.loaderSubject.next(<LoaderState>{show: true});
            },
            500);
    }
    hide() {
        this.shouldShow = false;
        this.loaderSubject.next(<LoaderState>{show: false});
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/loader/loader.service.ts